module.exports = __webpack_public_path__ + "media/assets/images/icons/countries/jp-4a160994709b7e55c26c6808d946922e.svg";